import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';

export function* getSpearPartsList(action: any): any {
    try {
        const data = action.payload;
        console.log('SSSSSSSSSSSSAAAAAAAAAAAAAAAAGGGGGGGGGGGGGAAAAAAAAAAAAAAAAAA', data);
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_SPEAR_PARTS_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getSpearPartsCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_SPEAR_PARTS_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveSpearParts(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SPEAR_PARTS.SAVE_SPEAR_PARTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* deleteSpearParts(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.SPEAR_PARTS.DELETE_SPEAR_PARTS + "?PartID=" + data.partsID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getPartsAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_PARTS_ATTACHMENTS  , data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* savePartsAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SPEAR_PARTS.SAVE_PARTS_ATTACHMENTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* savePartsImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SPEAR_PARTS.SAVE_PARTS_IMAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deletePartsAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.SPEAR_PARTS.DELETE_PARTS_ATTACHMENTS + "?PartsAttachmentID=" + data.PartsAttachmentID , data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* exportToPdf(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.EXPORT_TO_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* exportToXls(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.EXPORT_TO_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportQRCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SPEAR_PARTS.EXPORT_QR_CODE, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* getPartsStatus(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_PARTS_STATUS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getSparePartsCategoryList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_PARTS_CATEGORY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getPartsUnitList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_PARTS_UNIT_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetPartsNotesList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_PARTS_NOTES_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SavePartsNotes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SPEAR_PARTS.SAVE_PARTS_NOTES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}




export function* locationWiseStock(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.LOCATION_WISE_STOCK, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getPurchaseHistory(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.PURCHASE_HISTORY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getStockPickingHistory(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.STOCK_PICKING_HISTORY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getStockCycleCountHistory(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.STOCK_CYCLE_COUNT_HISTORY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getStockAdjustmentHistory(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.STOCK_ADJUSTMENT_HISTORY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* SavePartsVendorMap(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SPEAR_PARTS.SAVE_PARTS_VENDOR_MAP, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeletePartsVendorMap(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.SPEAR_PARTS.DELETE_PARTS_VENDOR_MAP, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getCurrentStockDetails(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_CURRENT_STOCK_DETAILS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getPersonalStockReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.GET_PERSONAL_STOCK_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* exportReportToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SPEAR_PARTS.EXPORT_REPORT_TO_XLS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}










